export let VALIDATION_ERROR_MESSAGES = /*#__PURE__*/function (VALIDATION_ERROR_MESSAGES) {
  VALIDATION_ERROR_MESSAGES["NOT_VALID_ON_SAVE"] = "Please make sure the values entered above are correct";
  VALIDATION_ERROR_MESSAGES["NOT_VALID_ON_LEAVE"] = "Please make sure the values entered on this step are correct";
  VALIDATION_ERROR_MESSAGES["SHIPOUT_IN_SHUTDOWN_STATE"] = "Gift giveaway submissions are currently unavailable.";
  return VALIDATION_ERROR_MESSAGES;
}({});
export const TOOLTIP_ERROR_MESSAGE = {
  SELECT_PRODUCTS: 'Please select products to proceed'
};